<template>
  <div v-if="appReady" id="app" :class="'dog-' + dog.name">
    <link v-for="url in customStylesheets" rel="stylesheet" :href="url" :key="url">
    <BrandColors />
    <Header :dogLogoUrl="dogLogoUrl" />
    <div class="container-fluid">
      <div class="main-content row">
        <div class="col-md-8">
          <Video
            v-if="videoUrl"
            :videoUrl="videoUrl"
            :videoTitle="videoTitle" />
          <Leaderboard v-else-if="this.$store.state.leaderboards[0]" :lb="this.$store.state.leaderboards[0]" />
        </div>
        <div class="col-md-4">
          <DonorWall :donations="recentDonations" />
        </div>
      </div>
    </div>
    <ScrollingTicker v-if="this.$store.state.stats.hasOwnProperty('total_amount_raised')" />
  </div>
  <div v-else class="loading-pulse">
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BrandColors from './components/BrandColors.vue'
import confettiIntervals from './mixins/confettiIntervals.js'
import DonorWall from './components/DonorWall.vue'
import Header from './components/Header.vue'
import Leaderboard from './components/Leaderboard.vue'
import ScrollingTicker from './components/ScrollingTicker.vue'
import Video from './components/Video.vue'
import realtimeStats from './realtimeStats.js'
import store from './store/index.js'

export default {
  name: 'App',
  store,
  components: {
    BrandColors,
    DonorWall,
    Header,
    Leaderboard,
    ScrollingTicker,
    Video
  },
  mixins: [confettiIntervals],
  data () {
    return {
      appReady: false,
    }
  },
  computed: {
    ...mapGetters(['custom']),
    customStylesheets () {
      return this.custom('external_stylesheets');
    },
    dog () {
      return this.$store.state.dog;
    },
    dogLogoUrl () {
      return `https://giving-day-content.givegab.com/${this.dog.name}/app/images/day-of-giving-logo-dark.svg`
    },
    recentDonations () {
      return this.$store.state.donations.slice(0, 4);
    },
    videoUrl () {
      return this.custom('live_app_video_url');
    },
    videoTitle () {
      return `${this.dog.title} ${this.dog.landing_page} video`;
    },
  },
  beforeCreate() {
    store.dispatch('loadDog').then( () => {
      store.dispatch('loadCustomizations').then( () => {
        this.appReady = true;
        store.dispatch('loadStats');
        store.dispatch('loadLeaderboards');
        store.dispatch('loadRecentDonations');
        realtimeStats.connect();
      });
    });
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #6d6d6d;
}
.main-content {
  padding-top: 2rem;
  padding-bottom: 10vh;

  @media screen and (min-width: 768px) {
    padding-top: 3vh;
    padding-bottom: 0;
    height: 70vh;
    overflow-y: hidden;
  }
}
</style>
